<template>
  <div class="xs12 flex mt-2">
    <v-flex
      style="background-color: #222; color: #eee; line-height: 28px;"
      class="pl-3 xs12 "
    >
      <h3
        class="xs12"
        style="font-size: 16px; text-weigth: 100; height: 28px;"
      >
        <span>{{ text }}</span>
         <v-btn round light target="_blank" small flat
          v-if="showAddLink"
          color="white"
          @click="showAdd"
          style="text-decoration: none !important; background-color:#392939;"
          class="black--text right mr-2 mb-0 pl-1 mt-1 pr-2 xs12" rel="noopener noreferrer">
          <v-icon small color="white" class="mr-2">add</v-icon>
          <span class="mt-0">Add new Link</span>
        </v-btn>
     </h3>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: ['text','showAddLink'],
  methods: {
    showAdd () {
      this.$emit('showAdd')
    }
  }
}
</script>

<style lang="css" scoped>
.v-btn--small {
  height: 22px !important;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SectionHeader.vue